'use client';

// import { useTranslations } from 'next-intl';

import { cn } from '@/libs/utils';

const BaseTemplate = (props: {
  // leftNav: React.ReactNode;
  // rightNav?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}) => {
  // const t = useTranslations('BaseTemplate');

  return (
    // <QueryClientProvider client={queryClient}>
    <div className={cn('w-screen text-gray-700 antialiased', props.className)}>
      <main>{props.children}</main>
    </div>
    // </QueryClientProvider>
  );
};

export { BaseTemplate };
